var App = App || {};

App.ComponentGallery = (function ($) {
    'use strict';

    function Masonry() {

        const gallery = $(".component-gallery-layout");

        MasonryInit();
        $(document).bind("enter-lg enter-xl enter-xxl enter-md enter-sm enter-xs", function () {
            MasonryDestroy();
            MasonryInit();
        });

        function MasonryInit() {
            gallery.masonry({
                itemSelector: ".component-gallery-image-sizer",
                transitionDuration: '0.1s'
            });
        }

        function MasonryDestroy() {
            var msnry = gallery.data('masonry');
            if (msnry !== undefined)
                gallery.masonry("destroy");
        }
    }

    function Popover() {
        const popoverTriggerList = document.querySelectorAll(".component-gallery .component-gallery-image > a")
        const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
    }

    function ViewAll() {

        const gallery = $(".component-gallery");

        gallery.each(function () {

            const frame = $(this).find(".component-gallery-frame");
            const handle = $(this).find(".component-gallery-handle");
            const trigger = $(this).find(".component-gallery-handle > button");
            const layout = $(this).find(".component-gallery-layout");

            trigger.on("click", function () {
                const height = layout.height();
                frame.animate({ height: height }, 300, function () {
                    $(this).removeAttr("style");
                    handle.remove();
                });

            });

        });

    }

    return {
        Masonry: Masonry,
        Popover: Popover,
        ViewAll: ViewAll
    };

})(jQuery);

$(function () {
    App.ComponentGallery.Masonry();
    App.ComponentGallery.Popover();
    App.ComponentGallery.ViewAll();
});